import { createContext } from 'react';

export const TimeseriesChartLoadingContext = createContext<boolean | undefined>(
  undefined,
);

TimeseriesChartLoadingContext['displayName'] = 'TimeseriesChartLoadingContext';
